/**
 * @format
 * @Author: 李一番
 * @Date: 2023-03-15 17:49:26
 * @Last Modified by: liyifan
 * @Last Modified time: 2023-08-23 10:21:14
 * @description 埋点封装
 */

/**
 * @description GTM事件处理
 * @param {*} params 参数传递
 */
const handleGTM = (params) => {
  if(!window.dataLayer) return
  window.dataLayer.push({ event_parameters: null });
  window.dataLayer.push(params);
};

/**
 * @description ga4 events
 * @param {String} type
 * gtm: gtm /
 * @param {Object} params
 */
const buriedEvent = {
  // 产品购买页加载
  viewProductItem: (params) => {
    handleGTM(params)
  },
  // 产品购买页 - 加入购物车按钮
  addToCart: (params) => {
    handleGTM(params)
  },
  // 产品购买页面 - Buy Now按钮
  buyNow: (params) => {
    handleGTM(params)
  },
  // 购物车页 - 结算按钮
  checkout: (params) => {
    handleGTM(params)
  },
  // 支付成功页 - 支付成功
  paymentSuccess: (params) => {
    handleGTM(params)
  },
  // 页面加载
  pageLoad: (params) => {
    handleGTM(params)
  },
  // 顶部提示横幅 - 优惠券
  topTipBanner: (params) => {
    handleGTM(params)
  },
  // 顶部导航 - 一级导航
  topNavigation: (params) => {
    handleGTM(params)
  },
  // 顶部导航 - 二级导航
  secondNavigation: (params) => {
    handleGTM(params)
  },
  // 顶部导航 - 三级导航
  thirdNavigation: (params) => {
    handleGTM(params)
  },
  // 顶部功能按钮
  topFunctions: (params) => {
    handleGTM(params)
  },
  // 首页 - 推荐产品 - 列表产品
  recommendedProductList: (params) => {
    handleGTM(params)
  },
  // 首页 - 推荐产品 - 产品点击
  recommendedProductListClick: (params) => {
    handleGTM(params)
  },
  // 首页 - 主打产品 - 产品曝光
  featuredProduct: (params) => {
    handleGTM(params)
  },
  // 首页 - 主打产品 - 产品点击
  featuredProductClick: (params) => {
    handleGTM(params)
  },
  // 首页 - 订阅 - 订阅按钮
  subscriptionButton: (params) => {
    handleGTM(params)
  },
  // 首页 - 加入联盟
  joinOnAffiliate: (params) => {
    handleGTM(params)
  },
  // 产品详情 - 立即购买
  buyNow: (params) => {
    handleGTM(params)
  }
}

window.buriedEvent = buriedEvent
$(document).ready(function () {
  const pageLoadParams = {
    user_id: pageInfo.customerInfo.id,
    country_code: Shopify?.country
  }
  buriedEvent.pageLoad(pageLoadParams);
  // 顶部提示横幅 - 优惠券
  $('.announcement-bar .jackery-icon-guanbi,.announcement-bar .announcement__link').click(function (e) {
    const itemType = $(this).siblings('.countdown').length > 0 ? 'countdown + ' : '';
    const bannerTxt = $(this).siblings('.announcement__text').text().trim() || '';
    let params = {
      event: 'ga4Event',
      event_name: 'top_tip_banner',
      event_parameters: {
        current_page: window.location.href, // current page url，用户当前浏览的页面地址URL
        banner_name: itemType + bannerTxt
      },
    };

    let btnName;
    if ($(this).hasClass('announcement__link')){
      btnName = $(this).text().trim() || 'button';
      params.event_parameters.link = $(this).attr('href') || '';
    } else {
      btnName = 'close';
    }
    params.event_parameters.button_name = btnName;
    buriedEvent.topTipBanner(params);
  });

  // 顶部导航 - 一级导航 - PC
   $('.nav-item.underlines-btn').mouseenter(function (e) {
      let text
      if($(e.target).hasClass('nav-item') && $(e.target).parent().hasClass('header-navs')) {
       if($(e.target).find('.first_nav_top').length > 0) {
         text = $(e.target).find('.first_nav_top').text().trim()
       } else {
         text = $(e.target).contents().filter(function() {
          return this.nodeType == Node.TEXT_NODE;
         }).text().trim()
         if(!text) {
           text = $(e.target).find('.first_nav_top_name').text().trim()
         }
       }

      const params = {
        event: 'ga4Event',
        event_name: 'top_first_nav',
        event_parameters: {
          current_page: document.title,
          first_nav: text
        }
      }
      buriedEvent.topNavigation(params);
     }
   })

  // 顶部导航 - 一级导航 - Mobile
  $(".m-h-menu .mobile-nav-product-header,.menu-li>.m-menu-content:not(.nav-collection-header,.mobile-nav-product-header)").click(function(e) {
    buriedEvent.topNavigation({
      event: 'ga4Event',
      event_name: 'top_first_nav',
      event_parameters: {
        current_page: document.title,
        first_nav: $(e.target).text().trim()
      },
    });
  })

  // 顶部导航 - 二级导航 - PC
  $('.nav-item-menu .nav-menuItem-list .nav-menuItem,.nav-shop-scence .nav-shop-scence-item').click(function (e) {
    let first_nav
    if($(this).closest('.nav-item').find('.first_nav_top').length > 0) {
     first_nav = $(this).closest('.nav-item').find('.first_nav_top').text().trim()
    } else {
      first_nav = $(this).closest('.nav-item').contents().filter(function() {
       return this.nodeType == Node.TEXT_NODE;
      }).text().trim()
      if(!first_nav) {
        first_nav = $(this).closest('.nav-item').find('.first_nav_top_name').text().trim()
      }
    }

    let text = ''
    if($(this).hasClass('nav-shop-scence-item')) {
      text = $(this).find('span').text().trim()
    } else {
      text = $(this).contents().filter(function() {
        return this.nodeType == Node.TEXT_NODE;
      }).text();
    }

    const params = {
      event: 'ga4Event',
      event_name: 'top_second_nav',
      event_parameters: {
        current_page: document.title,
        first_nav,
        second_nav: text.trim(),
      }
    }
    buriedEvent.secondNavigation(params);
  })
  // 顶部导航 - 二级导航 - Mobile
  $(".m-header-scence-item, .nav-child-item .nav-child-content").click(function(e) {
    e.preventDefault()
    let first_nav = $(this).closest('.menu-li').find('.m-menu-content .m-menu-item-name').first().text().trim()
    let second_nav = $(e.target).text().trim()
    buriedEvent.secondNavigation({
      event: 'ga4Event',
      event_name: 'top_second_nav',
      event_parameters: {
        current_page: document.title,
        first_nav,
        second_nav,
      }
    });
    location.href = $(this).attr('href')
  })

  // 顶部导航 - 三级导航 - PC
  $('.nav-shop-collection-products .collection-products-item,.a-button-fill.nav-shop-collection-more').click(function (e) {
    e.preventDefault()
    let third_nav = ''
    let second_nav = ''
    let first_nav = ''

    if($(this).closest('.nav-item').find('.first_nav_top').length > 0) {
     first_nav = $(this).closest('.nav-item').find('.first_nav_top').text().trim()
    } else {
      first_nav = $(this).closest('.nav-item').contents().filter(function() {
       return this.nodeType == Node.TEXT_NODE;
      }).text().trim()
      if(!first_nav) {
        first_nav = $(this).closest('.nav-item').find('.first_nav_top_name').text().trim()
      }
    }

    second_nav = $('.collection-taps-item.active').text().trim()
    if($(e.target).hasClass('nav-shop-collection-more')) {
      third_nav = $(this).text().trim()
    } else {
      third_nav = $(this).find('span').text().trim()
    }

    const params = {
      event: 'ga4Event',
      event_name: 'top_third_nav',
      event_parameters: {
        current_page: document.title,
        first_nav,
        second_nav,
        third_nav
      },
    }
    buriedEvent.thirdNavigation(params);
    location.href = $(this).attr('href')
  })
  // 顶部导航 - 三级导航 - Mobile
  $(".mb-menu-product-line,.collection-more a").click(function(e) {
    e.preventDefault()
    let third_nav = ''
    let second_nav = ''
    let first_nav = $('.mobile-nav-product-header').text().trim()

    second_nav = $(e.target).closest('.menu-li.active').find('.nav-collection-header').text().trim()
    if($(e.target).hasClass('a-button-fill')) {
      third_nav = $(this).text().trim()
    } else {
      third_nav = $(this).find('span').text().trim()
    }
    buriedEvent.thirdNavigation({
      event: 'ga4Event',
      event_name: 'top_third_nav',
      event_parameters: {
        current_page: document.title,
        first_nav,
        second_nav,
        third_nav
      },
    });
    location.href = $(this).attr('href')
  })

  // 顶部功能按钮
  $('.header-icons .header__search .iconfont.jackery-icon-sousuo').click(function (e) {
    topFunctions('search')
  })
  $('.header-icons .jackery-icon-yonghu').click(function (e) {
    topFunctions('account')
  })
  $('.header-icons #cart-icon-bubble').click(function (e) {
    topFunctions('cart')
  })
  const topFunctions = (text) => {
    const params = {
      event: 'ga4Event',
      event_name: 'top_function',
      event_parameters: {
        current_page: document.title,
        button_name: text
      }
    }
    buriedEvent.topFunctions(params);
  }

  // 首页 - 主打产品 - 产品点击
  $('.index-product-slide-content .z-button-fill-middle').click(async function (e) {
    e.preventDefault()
    const url = $(this).attr('href')
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
    })
    const res = await response.json()

    const { product } = res
    const items = product.variants.map((item, index) => {
      const obj = {
        currency: pageInfo.currency.currency,
        index,
        item_id: item.id,
        item_name: `${product.title} ${item.title}`,
        // item_category: product.collections,
        item_variant: item.title,
        item_brand: location.host,
        price: item.price
      }
      return obj
    })
    const params = {
      event: 'ga4Event',
      event_name: 'select_item',
      event_parameters: {
        current_page: document.title,
        item_list_name: product.title,
        items
      }
    }
    buriedEvent.featuredProductClick(params)
    location.href = url
  })

  // 首页 - 推荐产品 - 产品点击
  $(".collection-swiper .slide-content a").click(function(e) {
    e.preventDefault()
    const params = {
      event: 'ga4Event',
      event_name: 'select_banner',
      event_parameters: {
        current_page: document.title,
        banner_name: $('.swiper-slide-active .slid-collection-title').text().trim(),
        banner_url: $(this).attr('href')
      }
    }
    buriedEvent.recommendedProductListClick(params);
    location.href = $(this).attr('href')
  })

  // 产品详情页 - begin_checkout
  function initPaymentDom() {
    const payMoreOptions = $(".shopify-payment-button__more-options:not('.shopify-payment-button__button--hidden')") // buy it now 备用
    if(payMoreOptions.length >= 1) {
       payMoreOptions.click(function(e) {
        buriedEvent.buyNow({
          event: 'ga4Event',
          event_name: 'begin_checkout',
          event_parameters: {
            current_page: document.title,
            button_name: 'BUY IT NOW',
            currency: pageInfo.currency.currency,
            value: $('.product-main-block').attr('data-price') * $("[name=quantity]").val() / 100,
            items: [{
              currency: pageInfo.currency.currency,
              "item_id": $('.product-main-block').attr('data-id'),
              "item_name": $('.meta h1').text().trim(),
              "price": $('.product-main-block').attr('data-price') / 100,
              "quantity": $("[name=quantity]").val()
            }]
          }
        });
        // US和CA TTD埋码
        if(shopId === '9709262' || shopId === '60738666677') {
          var img = new Image();
          img.src = 'https://insight.adsrvr.org/track/pxl/?adv=xg3q3ge&ct=0:m65rtrd&fmt=3'
        }
      })
    } else {
      setTimeout(() => {
        initPaymentDom()
      }, 50)
    }
  }
  if(location.pathname.indexOf('/products/') !== -1) {
    initPaymentDom()
  }
})

export default buriedEvent
